import React from 'react';
import { Link } from 'react-router-dom';

const VALUES = ['Partnership', 'Independence', 'Curiosity', 'Focus', 'Proof'];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="frame site-footer__inner">
        <div className="site-footer__brand">
          <img
            src="/img/lh_logo-white-1200x387.webp"
            alt="RussellStone Lighthouse"
          />
          <p className="site-footer__tag">
            We find the <em>one</em> constraint limiting everything else, fix it alongside your team, and leave.
          </p>
        </div>

        <div className="site-footer__col">
          <h5>Pages</h5>
          <Link to="/approach">Approach</Link>
          <Link to="/principles">Principles</Link>
          <Link to="/history">History</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="site-footer__col">
          <h5>Contact</h5>
          <p>
            <a href="mailto:contact@rslighthouse.com">contact@rslighthouse.com</a>
          </p>
          <p>510 Makou St · Monument Park · Pretoria</p>
          <p>Within 24 hours</p>
        </div>
      </div>

      <div className="frame site-footer__values">
        <div className="vals">
          {VALUES.map((v, i) => (
            <React.Fragment key={v}>
              {v}
              {i < VALUES.length - 1 && <span>·</span>}
            </React.Fragment>
          ))}
        </div>
        <div className="site-footer__copy">
          © {currentYear} RussellStone Lighthouse (Pty) Ltd · All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
